import { OrderDetailResponse, OrderReviewResponse } from "../models/order";
import { backend } from "../utils/axios";

const ROUTE = "/orders";

interface OrdersServiceEndpoints {
  getDetails: (orderId: string) => Promise<OrderDetailResponse>;
  getReview: (
    typeId: number,
    electionDate: string
  ) => Promise<OrderReviewResponse>;
  getS3Link: (orderId: string, type: "download" | "print") => Promise<string>;
}

export const OrdersService: OrdersServiceEndpoints = {
  getDetails: (orderId) =>
    backend
      .get<OrderDetailResponse>(`${ROUTE}/details/${orderId}`)
      .then(({ data }) => data)
      .catch(),
  getReview: (typeId, electionDate) =>
    backend
      .get<OrderReviewResponse>(
        `${ROUTE}/review/${typeId}/${electionDate}T05:00:00Z`
      )
      .then(({ data }) => data)
      .catch(),
  getS3Link: (orderId, type) =>
    backend
      .get<string>(`${ROUTE}/s3link/${orderId}/${type}`)
      .then(({ data }) => data)
      .catch(),
};
